import {Component, ViewChild} from '@angular/core';
import {NavController, NavParams, Platform, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {TGoogleAnalytic, Util} from '../../../app/util';
import {
    TAction,
    TClusterTipo,
    TEstoqueOlho,
    TImageModel,
    TPrecifyMenu,
    TPrecifyOlho,
    TProdutoView,
} from "../../../app/enum";
import {WebstorService} from "../../../providers/webstor-service";
import {Searched} from "../../../components/searched/searched";
import {BarcodeScanner} from "@ionic-native/barcode-scanner";
import {MessageService} from "../../../providers/message-service";
import {ProdutoViewPage} from "../produto-view/produto-view";


@Component({
    selector: 'page-produto-menu',
    templateUrl: 'produto-menu.html',
    providers: [WebstorService]
})
export class ProdutoMenuPage {

    TProdutoView: any = TProdutoView;
    TPrecifyMenu: any = TPrecifyMenu;
    TImageModel: any = TImageModel;

    config: any;

    filtered: any;
    closters: any;
    clusters: any;
    indexes: any;
    indexDT: number = -1;

    rootspot: any;
    themedep: any;

    etapa: number;
    _count: number = 5;

    prodsee: number = 0;

    clusterTipo: TClusterTipo;
    servicoBool: boolean;
    produtoFull: boolean;
    produtoView: TProdutoView;

    precifyMenu: TPrecifyMenu;
    precifyOlho: TPrecifyOlho;
    estoqueOlho: TEstoqueOlho;

    @ViewChild(Searched) searched: Searched;

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public webstorService: WebstorService, public barcodeScanner: BarcodeScanner,
                public viewCtrl: ViewController, public messageService: MessageService,
                public platform: Platform, public util: Util) {


        this.config = CONFIG;

        this.etapa = this.navParams.get('etapa');

        this.clusters = this.navParams.get('clusters');
        this.indexes = this.navParams.get('indexes');

        this.rootspot = this.navParams.get('rootspot');
        this.themedep = this.navParams.get('themedep');

        this.clusterTipo = this.navParams.get('clusterTipo');
        this.servicoBool = this.navParams.get('servicoBool');
        this.produtoFull = this.navParams.get('produtoFull');
        this.produtoView = this.navParams.get('produtoView');

        this.precifyMenu = this.navParams.get('precifyMenu');
        this.precifyOlho = TPrecifyOlho.pcCash;
        this.estoqueOlho = TEstoqueOlho.esQtde;

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Produto Menu', '/produto-menu');

        if (this.etapa == 0) this.clusterLoad('');
        if (this.etapa == 1) this.clusterLoad('');

    }

    getTitle() {

        if (this.etapa == 0) return (this.produtoView == TProdutoView.pdPrecify ? 'Preço' : 'Estoque');
        if (this.etapa == 1) return 'Cluster';
        if (this.etapa == 2) return this.clusters[this.indexes.indexCA].Clusters[this.indexes.indexCB].ClusterNome;

    }

    produtoGtin() {

        let loading = this.util.loadingDots();
        loading.present();

        let option = {showTorchButton: true};
        this.barcodeScanner.scan(option).then(
            data => {

                loading.dismiss();
                if (data.cancelled) return;
                this.clusterLoad(data.text);

            }).catch(
            erro => {

                loading.dismiss();
                let text = (!this.platform.is('cordova') ? 'Camera apenas no ambiente "Cordova"' : 'Você precisa fornecer acesso a sua camera para continuar.' + '<br><br>' + erro);
                this.util.alertSimply(text);

            });

    }

    clusterLoad(produtoGtin) {

        //..acLoad => Todos os produtos
        //..acHave => Somente os adicionados em Precify ou Estoque
        let action = (this.produtoFull || produtoGtin ? TAction.acLoad : TAction.acHave);
        let hotspotID = (this.rootspot ? this.rootspot.Hotspots[0].HotspotID : 0);

        let loading = this.util.loadingDots();
        loading.present();

        if (!produtoGtin) this.clusters = null;
        this.webstorService.cluster(action, hotspotID, produtoGtin, this.clusterTipo, this.produtoView)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    //GTIN-FIND
                    if (produtoGtin) {
                        if (!data.Clusters.length) {
                            this.util.toastSimply('GTIN não encontrato');
                            return;
                        }
                        let clusterID = data.Clusters[0].Clusters[0].ClusterID;
                        let blendedID = data.Clusters[0].Clusters[0].Clusters[0].Blendeds[0].BlendedID;
                        let packageID = data.Clusters[0].Clusters[0].Clusters[0].Blendeds[0].Packages[0].PackageID;
                        let produtoID = data.Clusters[0].Clusters[0].Clusters[0].Blendeds[0].Packages[0].Produtos[0].ProdutoID;
                        this.produtoOpen(data.Clusters, clusterID, blendedID, packageID, produtoID);
                        return;
                    }

                    //DEPOSIT-THEME
                    if (this.produtoView == TProdutoView.pdEstoque && !this.themedep) {
                        let depositID = this.rootspot.Hotspots[0].Deposit.DepositID;
                        this.themedep = data.Deposits.find(DT => DT.DepositID == depositID);
                        this.themedep.Deposits.forEach(DT => DT._show = false);
                    }

                    this.clusters = data.Clusters;

                    let onLoop = (CA, CB, CC, BL, PK, PD) => {

                        //DEPOSIT-USED -> POPULATE
                        (PD.Estoques || []).map(ES => {
                            let deposit = this.themedep.Deposits.find(DT => DT.DepositID == ES.DepositID);
                            deposit._show = true;
                        });

                    };

                    this.clusterLoop(onLoop);
                    this.rowlineData();

                },
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    clusterLoop(onLoop: Function = null) {

        this.clusters.map(CA => {
            CA.Clusters.map(CB => {
                CB.Clusters.map(CC => {
                    (CC.Blendeds || []).map(BL => {
                        (BL.Packages || []).map(PK => {
                            (PK.Produtos || []).map(PD => {

                                onLoop(CA, CB, CC, BL, PK, PD);

                            });
                        });
                    });
                });
            });
        });

    }

    produtoOlho(flug: null | 'icon'): string {

        if (this.produtoView == TProdutoView.pdPrecify) {

            if (flug == 'icon') {
                if (this.precifyOlho == TPrecifyOlho.pcCash) return 'b-icon-dollar';
                if (this.precifyOlho == TPrecifyOlho.pcGorj) return 'b-icon-black-tie';
                if (this.precifyOlho == TPrecifyOlho.pcCoin) return 'b-icon-box';
                return null;
            }

            let onOlho = (olho) => {
                this.precifyOlho = olho;
                this.prodsee = 3;
            };

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Preço',    handler: () => onOlho(TPrecifyOlho.pcCash)});
            buttons.push({text: 'Gorjeta',  handler: () => onOlho(TPrecifyOlho.pcGorj)});
            buttons.push({text: 'Comissão', handler: () => onOlho(TPrecifyOlho.pcCoin)});
            this.util.sheetOpen(buttons, 'VISUALIZAR');
            return null;

        }

        if (this.produtoView == TProdutoView.pdEstoque) {

            if (flug == 'icon') {
                if (this.estoqueOlho == TEstoqueOlho.esCash) return 'b-icon-dollar';
                if (this.estoqueOlho == TEstoqueOlho.esQtde) return 'b-icon-th-1';
                return null;
            }

            let onOlho = (olho) => {
                this.estoqueOlho = olho;
                this.prodsee = 3;
            };

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Imobilizado', handler: () => onOlho(TEstoqueOlho.esCash)});
            buttons.push({text: 'Quantidade',  handler: () => onOlho(TEstoqueOlho.esQtde)});
            this.util.sheetOpen(buttons, 'VISUALIZAR');
            return null;

        }

    }

    depositOpen(show) {

        let onLoad = (index) => {

            if (!show) this.themedep.Deposits[index]._show = true;

            this.indexDT = index;
            this.rowlineData();

        };

        /** OPEN **/
        let buttons: Array<any> = [];
        if (show) buttons.push({text: 'Total', handler: () => onLoad(-1)});
        this.themedep.Deposits.forEach((DT, index) => {
            if (DT._show == show) buttons.push({text: DT.DepositNome, handler: () => onLoad(index)})
        });
        if (show) buttons.push({text: 'Configurar', cssClass: this.util.sheetClass(), handler: () => this.depositOpen(false)});
        this.util.sheetOpen(buttons, 'DEPÓSITO', 0);

    }

    depositLixo() {

        let depositID = this.themedep.Deposits[this.indexDT].DepositID;

        let onLoop = (CA, CB, CC, BL, PK, PD) => {

            //DEPOSIT-USED -> POPULATE
            let index = (PD.Estoques || []).findIndex(ES => ES.DepositID == depositID);
            if (index >= 0) PD.Estoques.splice(index, 1);

        };

        this.clusterLoop(onLoop);

        this.themedep.Deposits[this.indexDT]._show = false;
        this.indexDT = -1;

    }

    precifyOpen() {

        let onMenu = (menu) => {
            this.precifyMenu = menu;
            this.rowlineData();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Normal',   handler: () => onMenu(TPrecifyMenu.pcNormal)});
        buttons.push({text: 'Popular',  handler: () => onMenu(TPrecifyMenu.pcPopular)});
        buttons.push({text: 'Especial', handler: () => onMenu(TPrecifyMenu.pcEspecial)});
        this.util.sheetOpen(buttons, 'PREÇO');

    }

    precifyNada() {

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.precify(TAction.acNada, this.precifyMenu, 0, this.rootspot.Hotspots[0].HotspotID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.clusterLoad(''),
                erro => this.util.alertResult(erro)
            );

    }

    filterArrays(terms) {

        let array = this.util.deepCopy(this.closters);

        if (!terms) {
            this.filtered = array;
            return;
        }

        if (this.etapa == 1) {
            this.prodsee = 2;
            this.etapa = 0;
            this.rowlineData();
            return;
        }

        let result: any[] = [];
        array.forEach((root) => {

            let copy = this.util.deepCopy(root);
            copy.Rowlines = [];

            root.Rowlines.forEach(rowline => {

                let bool = this.util.filterSearch(false, root, terms, ['ClusterID', 'ClusterNome'], ['int', 'str']);
                if (this.prodsee >= 0 && !bool) bool = this.util.filterSearch(false, rowline.Branded, terms, ['BrandedID', 'BrandedNome'], ['int', 'str']);
                if (this.prodsee >= 1 && !bool) bool = this.util.filterSearch(false, rowline, terms, ['BlendedID', 'BlendedNome'], ['int', 'str']);
                if (this.prodsee >= 2 && !bool) bool = this.util.filterSearch(false, rowline.Package, terms, ['PackageID', 'PackageNome'], ['int', 'str']);
                if (this.prodsee >= 3 && !bool) bool = this.util.filterSearch(false, rowline.Package.Produto, terms, ['ProdutoID', 'ProdutoNome'], ['int', 'str']);
                if (bool) copy.Rowlines.push(rowline);

            });

            if (copy.Rowlines.length) result.push(copy);

        });

        this.filtered = result;

    }

    rowlineData() {

        this.closters = this.rowlineLoop(this.prodsee);
        if (this.searched) this.searched.searchStart();
        if (!this.searched) this.filterArrays(null);

    }

    rowlineLoop(prodsee, brandedID?, blendedID?, packageID?, produtoID?) {

        if (!this.clusters) return [];

        let result = [];

        let onLoop = (CA, CB, CC, BL, PK, PD) => {

            let filter = true;
            if (this.produtoView == TProdutoView.pdEstoque && this.indexDT >= 0) filter = !!PD.Estoques.find(ES => ES.DepositID == this.themedep.Deposits[this.indexDT].DepositID);
            if (this.produtoView == TProdutoView.pdPrecify && this.precifyMenu > 0) filter = !!PD.Precifys.find(PC => PC.PrecifyMenu == this.precifyMenu);

            //ROWLINE-CRIA -> POPULATE
            let brandedBool = (!brandedID || BL.Branded.BrandedID == brandedID);
            let blendedBool = (!blendedID || BL.BlendedID == blendedID);
            let packageBool = (!packageID || PK.PackageID == packageID);
            let produtoBool = (!produtoID || PD.ProdutoID == produtoID);

            if (filter && (brandedBool || blendedBool || packageBool || produtoBool)) {

                let line = null;
                let cluster = result.find(CL => CL.ClusterID == CB.ClusterID);

                if (cluster) {
                    if (prodsee == 0) line = cluster.Rowlines.find(ln => ln.Branded.BrandedID == BL.Branded.BrandedID);
                    if (prodsee == 1) line = cluster.Rowlines.find(ln => ln.BlendedID == BL.BlendedID);
                    if (prodsee == 2) line = cluster.Rowlines.find(ln => ln.BlendedID == BL.BlendedID && ln.Package.PackageID == PK.PackageID);
                    if (prodsee == 3) line = cluster.Rowlines.find(ln => ln.BlendedID == BL.BlendedID && ln.Package.PackageID == PK.PackageID && ln.Package.Produto.ProdutoID == PD.ProdutoID);
                }

                if (!cluster) {
                    cluster = this.util.deepCopy(CB);
                    cluster.Rowlines = [];
                    delete cluster.Clusters;
                    result.push(cluster);
                }

                let bool = !brandedID;
                if (prodsee == 1 && brandedID) bool = (BL.Branded.BrandedID == brandedID);
                if (prodsee == 2 && blendedID) bool = (BL.Branded.BrandedID == brandedID && BL.BlendedID == blendedID);
                if (prodsee == 3 && packageID) bool = (BL.Branded.BrandedID == brandedID && BL.BlendedID == blendedID && PK.PackageID == packageID);

                if (!line && bool) {
                    let copy = this.util.deepCopy(BL);

                    copy.Package = this.util.deepCopy(PK);
                    delete copy.Packages;

                    copy.Package.Produto = this.util.deepCopy(PD);
                    delete copy.Package.Produtos;

                    cluster.Rowlines.push(copy);
                }

            }

        };

        this.clusterLoop(onLoop);

        return result;

    }

    rowlineFlug(flug: 'symb' | 'nome' | 'note', rowline): string {

        let precifys = rowline.Package.Produto.Precifys;

        if (flug == 'symb') {
            if (this.prodsee == 0) return rowline.Branded.BrandedSymb;
            if (this.prodsee == 1) return rowline.Branded.BrandedSymb;
            if (this.prodsee == 2) return rowline.Branded.BrandedSymb;
            if (this.prodsee == 3) return rowline.Branded.BrandedSymb;
        }

        if (flug == 'nome') {
            if (this.prodsee == 0) return rowline.Branded.BrandedNome;
            if (this.prodsee == 1) return rowline.BlendedShow;
            if (this.prodsee == 2) return (rowline.BlendedShow + ' ' + rowline.Package.PackageNome).trim();
            if (this.prodsee == 3) return (rowline.BlendedShow + ' ' + rowline.Package.PackageNome + ' ' + rowline.Package.Produto.ProdutoNome).trim();
        }

        if (flug == 'note') {

            if (this.produtoView == TProdutoView.pdPrecify) {
                let precify = precifys.find(PC => PC.PrecifyMenu == this.precifyMenu);
                if (!precify) return '';

                if (this.precifyOlho == TPrecifyOlho.pcCash) return this.util.dinheiro(precify.PrecifyCash);
                if (this.precifyOlho == TPrecifyOlho.pcGorj) return (precify.PrecifyGorj ? 'Sim' : 'Não');
                if (this.precifyOlho == TPrecifyOlho.pcCoin) return (!precify.PrecifyCoin ? '' : (precify.PrecifyRule ? this.util.dinheiro(precify.PrecifyCoin) : this.util.porcenta(precify.PrecifyCoin)));
            }

            if (this.produtoView == TProdutoView.pdEstoque) {
                let estoques = rowline.Package.Produto.Estoques;
                if (this.indexDT >= 0) {
                    estoques = [];
                    let obj = rowline.Package.Produto.Estoques.find(ES => ES.DepositID == this.themedep.Deposits[this.indexDT].DepositID);
                    if (obj) estoques = [obj];
                }

                let estoqueQtde = this.util.jsSum(estoques, ['EstoqueQtde']);
                let estoqueCost = this.util.jsSum(estoques, ['EstoqueCost']);

                if (this.estoqueOlho == TEstoqueOlho.esCash) return this.util.dinheiro(estoqueQtde * estoqueCost);
                if (this.estoqueOlho == TEstoqueOlho.esQtde) return this.util.numerico(estoqueQtde);
            }

        }

        return '';
    }

    rowlineMore(cluster: any, press: boolean) {

        let count = cluster.Rowlines.length;
        let somar = (cluster._count || this._count) + this._count;
        cluster._count = (press ? count : somar);
        if (press) this.util.impact();

    }

    rowlineOpen(clusterID, rowline) {

        let onProduto = (blended) => {
            let clusters = this.util.deepCopy(this.clusters);
            this.produtoOpen(clusters, clusterID, blended.BlendedID, blended.Package.PackageID, blended.Package.Produto.ProdutoID);
        };

        let onPackage = (brandedID, blendedID, packageID) => {

            /** OPEN **/
            let buttons: Array<any> = [];
            let cluster = this.rowlineLoop(3, brandedID, blendedID, packageID).filter(CL => CL.ClusterID == clusterID)[0];
            let array = cluster.Rowlines;
            array.forEach(BL => buttons.push({text: BL.Package.Produto.ProdutoNome, handler: () => onProduto(BL)}));
            this.util.sheetOpen(buttons, 'TAMANHO', 0);

        };

        let onBlended = (brandedID, blendedID) => {

            /** OPEN **/
            let buttons: Array<any> = [];
            let cluster = this.rowlineLoop(2, brandedID, blendedID).filter(CL => CL.ClusterID == clusterID)[0];
            let array = cluster.Rowlines;
            array.forEach(BL => buttons.push({text: BL.Package.PackageNome, handler: () => onPackage(BL.Branded.BrandedID, BL.BlendedID, BL.Package.PackageID)}));
            this.util.sheetOpen(buttons, 'PACKAGE', 0);

        };

        let onBranded = () => {

            /** OPEN **/
            let buttons: Array<any> = [];
            let cluster = this.rowlineLoop(1, rowline.Branded.BrandedID).filter(CL => CL.ClusterID == clusterID)[0];
            let array = cluster.Rowlines;
            array.forEach(BL => buttons.push({text: BL.BlendedNome, handler: () => onBlended(rowline.Branded.BrandedID, BL.BlendedID)}));
            this.util.sheetOpen(buttons, 'BLEND', 0);

        };


        if (this.prodsee == 3) onProduto(rowline);
        if (this.prodsee == 2) onPackage(rowline.Branded.BrandedID, rowline.BlendedID, rowline.Package.PackageID);
        if (this.prodsee == 1) onBlended(rowline.Branded.BrandedID, rowline.BlendedID);
        if (this.prodsee == 0) onBranded();

    }

    clusterMenu(indexCA, indexCB) {

        if (this.etapa == 0) {

            let onOpen = (tipo) => {
                let object = {etapa: 1, servicoBool: this.servicoBool, clusterTipo: tipo, clusters: this.clusters, indexes: null, rootspot: this.rootspot, themedep: this.themedep, produtoFull: true, produtoView: this.produtoView, precifyMenu: TPrecifyMenu.pcNormal};
                this.util.modalopen(ProdutoMenuPage, 'alto', false, object).subscribe();
            };

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Contratação • Serviço',     handler: () => onOpen(TClusterTipo.clService)});
            buttons.push({text: 'Food • Beer • Smoke',       handler: () => onOpen(TClusterTipo.clEnjoy)});
            buttons.push({text: 'Mercado • Limpeza',         handler: () => onOpen(TClusterTipo.clMarket)});
            buttons.push({text: 'Saúde • Estilo • Magazine', handler: () => onOpen(TClusterTipo.clMagazine)});
            buttons.push({text: 'Pet • Toy • Sport',         handler: () => onOpen(TClusterTipo.clSport)});
            buttons.push({text: 'Motor • Construção',        handler: () => onOpen(TClusterTipo.clBuild)});
            this.util.sheetOpen(buttons, 'SETOR');

        }

        if (this.etapa == 1) {
            this.indexes = {indexCA: indexCA, indexCB: indexCB, indexCC: -1, indexBL: -1, indexPK: -1, indexPD: -1};
            let object = {etapa: 2, servicoBool: this.servicoBool, clusterTipo: this.clusterTipo, clusters: this.clusters, indexes: this.indexes, rootspot: this.rootspot, themedep: this.themedep, produtoFull: true, produtoView: this.produtoView, precifyMenu: TPrecifyMenu.pcNormal};

            if ( this.viewCtrl.isOverlay) this.util.modalopen(ProdutoMenuPage, 'alto', false, object).subscribe(data => this.dismiss(data));
            if (!this.viewCtrl.isOverlay) this.navCtrl.push(ProdutoMenuPage, object);
        }

    }

    produtoOpen(clusters, clusterID, blendedID, packageID, produtoID) {

        let IX = {indexCA: -1, indexCB: -1, indexCC: -1, indexBL: -1, indexPK: -1, indexPD: -1};
        IX.indexCA = clusters.findIndex(CA => !!CA.Clusters.find(CB => CB.ClusterID == clusterID));
        IX.indexCB = clusters[IX.indexCA].Clusters.findIndex(CB => CB.ClusterID == clusterID);
        IX.indexCC = clusters[IX.indexCA].Clusters[IX.indexCB].Clusters.findIndex(CC => !!CC.Blendeds.find(bl => bl.BlendedID == blendedID));
        IX.indexBL = clusters[IX.indexCA].Clusters[IX.indexCB].Clusters[IX.indexCC].Blendeds.findIndex(bl => bl.BlendedID == blendedID);
        IX.indexPK = clusters[IX.indexCA].Clusters[IX.indexCB].Clusters[IX.indexCC].Blendeds[IX.indexBL].Packages.findIndex(PK => PK.PackageID == packageID);
        IX.indexPD = clusters[IX.indexCA].Clusters[IX.indexCB].Clusters[IX.indexCC].Blendeds[IX.indexBL].Packages[IX.indexPK].Produtos.findIndex(PD => PD.ProdutoID == produtoID);


        //AKI - Comente mais acho que usa isso no contrato, testar!
        //Colocar dentro do Subscribe da modalopen?        
        //if (this.viewCtrl.isOverlay && this.clusterTipo == TClusterTipo.clService)  {
        if (this.viewCtrl.isOverlay && this.servicoBool)  {
            let produto = clusters[IX.indexCA].Clusters[IX.indexCB].Clusters[IX.indexCC].Blendeds[IX.indexBL].Packages[IX.indexPK].Produtos[IX.indexPD];
            let packagi = clusters[IX.indexCA].Clusters[IX.indexCB].Clusters[IX.indexCC].Blendeds[IX.indexBL].Packages[IX.indexPK];
            let blended = clusters[IX.indexCA].Clusters[IX.indexCB].Clusters[IX.indexCC].Blendeds[IX.indexBL];

            blended.Produto = produto;
            blended.Produto.Package = packagi;

            delete blended.Packages;
            delete packagi.Produtos;
            delete produto.Precifys;
            delete produto.Estoques;

            let resulta = {Blended: blended};
            this.dismiss(resulta);

            return;
        }

    
        let object = {etapa: 0, clusters: clusters, indexes: IX, rootspot: this.rootspot, themedep: this.themedep, produtoView: this.produtoView, precifyMenu: this.precifyMenu};
        this.util.modalopen(ProdutoViewPage, 'alto', false, object).subscribe();

    };

    blendedMenu(clusterID, blended) {


        let onProduto = (produtoID) => {
            let clusters = this.util.deepCopy(this.clusters);
            this.produtoOpen(clusters, clusterID, blended.BlendedID, blended.Package.PackageID, produtoID);
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        let array = blended.Package.Produtos;
        array.forEach(PD => buttons.push({text: PD.ProdutoNome, handler: () => onProduto(PD.ProdutoID)}));
        this.util.sheetOpen(buttons, 'TAMANHO', 0);

    }

    ngOnInit() {

        if (!this.viewCtrl.isOverlay) {
            console.log('CRIA');
            this.subscribeProdutoSpot(false);
        }

    }

    ngOnDestroy() {

        if (!this.viewCtrl.isOverlay) {
            console.log('DONE');
            this.subscribeProdutoSpot(true);
        }

    }

    subscribeProdutoSpot(done) {

        if (done) {
            //this.messageService.get('produto.spot').complete();
            //this.messageService.get('produto.spot').unsubscribe();
            return;
        }

        this.messageService.get('produto.spot')
            .subscribe(data => {

                if (data.action == 'save') {

                    let indexCA = this.clusters.findIndex(CA => CA.ClusterID == data.clusters[data.indexes.indexCA].ClusterID);
                    if (indexCA < 0) {
                        indexCA = this.clusters.length;
                        let CA = this.util.deepCopy(data.clusters[data.indexes.indexCA]);
                        CA.Clusters = [];
                        this.clusters.push(CA);
                    }

                    let indexCB = this.clusters[indexCA].Clusters.findIndex(CB => CB.ClusterID == data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].ClusterID);
                    if (indexCB < 0) {
                        indexCB = this.clusters[indexCA].Clusters.length;
                        let CB = this.util.deepCopy(data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB]);
                        CB.Clusters = [];
                        this.clusters[indexCA].Clusters.push(CB);
                    }

                    let indexCC = this.clusters[indexCA].Clusters[indexCB].Clusters.findIndex(CC => CC.ClusterID == data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].ClusterID);
                    if (indexCC < 0) {
                        indexCC = this.clusters[indexCA].Clusters[indexCB].Clusters.length;
                        let CC = this.util.deepCopy(data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC]);
                        CC.Blendeds = [];
                        this.clusters[indexCA].Clusters[indexCB].Clusters.push(CC);
                    }

                    let indexBL = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds.findIndex(BL => BL.BlendedID == data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].Blendeds[data.indexes.indexBL].BlendedID);
                    if (indexBL < 0) {
                        indexBL = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds.length;
                        let BL = this.util.deepCopy(data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].Blendeds[data.indexes.indexBL]);
                        BL.Packages = [];
                        this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds.push(BL);
                    }

                    let indexPK = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages.findIndex(PK => PK.PackageID == data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].Blendeds[data.indexes.indexBL].Packages[data.indexes.indexPK].PackageID);
                    if (indexPK < 0) {
                        indexPK = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages.length;
                        let PK = this.util.deepCopy(data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].Blendeds[data.indexes.indexBL].Packages[data.indexes.indexPK]);
                        PK.Produtos = [];
                        this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages.push(PK);
                    }

                    let indexPD = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages[indexPK].Produtos.findIndex(PD => PD.ProdutoID == data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].Blendeds[data.indexes.indexBL].Packages[data.indexes.indexPK].Produtos[data.indexes.indexPD].ProdutoID);
                    if (indexPD < 0) {
                        indexPD = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages[indexPK].Produtos.length;
                        let PD = this.util.deepCopy(data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].Blendeds[data.indexes.indexBL].Packages[data.indexes.indexPK].Produtos[data.indexes.indexPD]);
                        PD.Precifys = [];
                        this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages[indexPK].Produtos.push(PD);
                    }

                    let PX = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages[indexPK].Produtos[indexPD].Precifys.find(PC => PC.PrecifyID == data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].Blendeds[data.indexes.indexBL].Packages[data.indexes.indexPK].Produtos[data.indexes.indexPD].Precifys[data.indexes.indexPC].PrecifyID);
                    let PC = data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].Blendeds[data.indexes.indexBL].Packages[data.indexes.indexPK].Produtos[data.indexes.indexPD].Precifys[data.indexes.indexPC];
                    if (!PX) this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages[indexPK].Produtos[indexPD].Precifys.push(PC);
                    if ( PX) this.util.populateObj(PX, PC);

                    this.rowlineData();
                    console.log(this.clusters, data);

                }

                if (data.action == 'lixo') {

                    let indexCA = this.clusters.findIndex(CA => CA.ClusterID == data.clusters[data.indexes.indexCA].ClusterID);
                    let indexCB = this.clusters[indexCA].Clusters.findIndex(CB => CB.ClusterID == data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].ClusterID);
                    let indexCC = this.clusters[indexCA].Clusters[indexCB].Clusters.findIndex(CC => CC.ClusterID == data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].ClusterID);
                    let indexBL = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds.findIndex(BL => BL.BlendedID == data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].Blendeds[data.indexes.indexBL].BlendedID);
                    let indexPK = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages.findIndex(PK => PK.PackageID == data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].Blendeds[data.indexes.indexBL].Packages[data.indexes.indexPK].PackageID);
                    let indexPD = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages[indexPK].Produtos.findIndex(PD => PD.ProdutoID == data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].Blendeds[data.indexes.indexBL].Packages[data.indexes.indexPK].Produtos[data.indexes.indexPD].ProdutoID);
                    let indexPC = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages[indexPK].Produtos[indexPD].Precifys.findIndex(PC => PC.PrecifyID == data.clusters[data.indexes.indexCA].Clusters[data.indexes.indexCB].Clusters[data.indexes.indexCC].Blendeds[data.indexes.indexBL].Packages[data.indexes.indexPK].Produtos[data.indexes.indexPD].Precifys[data.indexes.indexPC].PrecifyID);

                    let precifys = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages[indexPK].Produtos[indexPD].Precifys;
                    let produtos = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages[indexPK].Produtos;
                    let packages = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds[indexBL].Packages;
                    let blendeds = this.clusters[indexCA].Clusters[indexCB].Clusters[indexCC].Blendeds;
                    let clusters = this.clusters[indexCA].Clusters[indexCB].Clusters;
                    let blusters = this.clusters[indexCA].Clusters;
                    let alusters = this.clusters;

                    precifys.splice(indexPC, 1);
                    if (precifys.length == 0) produtos.splice(indexPD, 1);
                    if (produtos.length == 0) packages.splice(indexPK, 1);
                    if (packages.length == 0) blendeds.splice(indexBL, 1);
                    if (blendeds.length == 0) clusters.splice(indexCC, 1);
                    if (clusters.length == 0) blusters.splice(indexCB, 1);
                    if (blusters.length == 0) alusters.splice(indexCA, 1);

                    this.rowlineData();

                }

            });

    }

    dismiss(data?) {

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss(data, 'back');
        }

        if (!this.viewCtrl.isOverlay) {
            //this.subscribeProdutoSpot(true);
            this.navCtrl.pop();
        }

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/produto-menu/produto-menu.ts